import { render, staticRenderFns } from "./Private.vue?vue&type=template&id=84e607e6&"
import script from "./Private.vue?vue&type=script&lang=ts&"
export * from "./Private.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports